import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { DotLoader } from '../../src/shared/feedback/loader/dot-loader.component';
import { ShowMail } from './components/show-mail.component';
import { MailService } from './services/MailService';

@NgModule({
  imports: [CommonModule, FormsModule, WooComponentsModule, DotLoader],
  providers: [MailService],
  declarations: [ShowMail],
  exports: [ShowMail],
})
export class WooMails {}
